import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Picture from '../Picture.jsx';
import blogConfig from '../../config/blogConfig.json';
import podcastConfig from '../../config/podcastConfig.json';

const mapStateToProps = state => ({
  routeParams: state.routeParams,
  siteBlogs: blogConfig[state.country],
  sitePodcasts: podcastConfig[state.country],
});

@connect(mapStateToProps)
export default class AuthorInfoLarge extends React.PureComponent {
  render() {
    const { sitePodcasts, siteBlogs, routeParams: { blogs, podcasts } } = this.props;

    let info;
    if (blogs) {
      info = _.find(siteBlogs, { id: blogs });
    } else if (podcasts) {
      info = _.find(sitePodcasts, { id: podcasts });
    }
    if (!info) return null;

    const square = require(`../../../assets/media-images/${info.images.square}`);

    return (
      <div className="author-info">
        <Picture className="image" src={square} alt={info.author} />
        <div className="highlight-box no-margin">
          <div className="section">
            <h4>{info.name}</h4>
            <div className="description">{info.description}</div>
          </div>
        </div>
      </div>
    );
  }
}

AuthorInfoLarge.propTypes = {
  sitePodcasts: React.PropTypes.array,
  siteBlogs: React.PropTypes.array,
  routeParams: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/AuthorInfoLarge.jsx